export default "__VITE_ASSET__Dz5FcA6Q__"